import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Label,
  Input,
  Button,
} from "reactstrap"
import { FaEye, FaEyeSlash } from "react-icons/fa"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import Swal from "sweetalert2"

// users
import user1 from "../../../assets/images/users/avatar-9.png"
import Configs, { axiosbaseurl } from "../../../config"
import secureLocalStorage from "react-secure-storage"

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const [passwordModal, setPasswordModal] = useState(false)
  const [newPassword, setNewPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const [user, setUser] = useState(secureLocalStorage?.getItem("admin_user"))

  const handleChangePassword = async e => {
    e.preventDefault()
    if (!newPassword) {
      Swal.fire({
        icon: "warning",
        title: "Please enter a new password",
      })
      return
    }

    setSubmitting(true)
    try {
      const res = await axiosbaseurl.post("auth/reset/password", null, {
        params: {
          email: user?.email,
          newPassword,
        },
      })

      if (res?.data?.success) {
        Swal.fire({
          icon: "success",
          title: "Password Updated",
          text: "Your password has been changed successfully.",
        })
        setPasswordModal(false)
        setNewPassword("")
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: res?.data?.message || "Could not update password.",
        })
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error?.response?.data?.message ||
          "Something went wrong. Please try again.",
      })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item text-white"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={
              user?.profilePicture
                ? `${Configs.imageUrl}${user?.profilePicture}`
                : user1
            }
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1 fw-bold fs-6 text-white">
            {user.name}
          </span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block text-white fs-6 fw-bold" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem
            tag="button"
            onClick={() => {
              setMenu(false)
              setPasswordModal(true)
            }}
          >
            {" "}
            <i className="bx bx-lock-alt font-size-16 align-middle me-1" />
            {"Change Password"}{" "}
          </DropdownItem>

          <div className="dropdown-divider" />
          <Link to={`${Configs.appurl}login`} className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{"Logout"}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>

      {/* Change Password Modal */}
      <Modal isOpen={passwordModal} centered>
        <ModalHeader toggle={() => setPasswordModal(false)}>
          Change Password
        </ModalHeader>
        <ModalBody style={{ padding: "20px" }}>
          <Form onSubmit={handleChangePassword}>
            <div className="mb-3">
              <Label className="form-label">Email</Label>
              <Input
                type="email"
                value={user?.email || ""}
                disabled
                readOnly
              />
            </div>

            <div className="mb-4">
              <Label className="form-label">New Password</Label>
              <div className="position-relative">
                <Input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  style={{ paddingRight: "40px" }}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="btn border-0 bg-transparent p-0"
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#64748b",
                    lineHeight: 1,
                  }}
                  tabIndex={-1}
                >
                  {showPassword ? <FaEyeSlash size={16} /> : <FaEye size={16} />}
                </button>
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2">
              <Button
                type="button"
                color="light"
                onClick={() => setPasswordModal(false)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={submitting}
                className="border-0 text-white"
                style={{
                  background: "#0077AC",
                  borderRadius: "8px",
                  padding: "8px 20px",
                  fontWeight: 500,
                }}
              >
                {submitting ? "Updating..." : "Update Password"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

export default ProfileMenu
